// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { nexilix as _nexilix } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the nexilix chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 240
 * Chain Name: Nexilix Smart Chain
 * Default Block Explorer: https://scan.nexilix.com
 * Default RPC URL: https://rpcurl.pos.nexilix.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { nexilix } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: nexilix,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const nexilix = createCommon({
	..._nexilix,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
